import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Only from "react-only-when";
import { PaxDetails, AddonsList } from "./";
import styles from "./styles.less";

const RoomBody = ({
  // id,
  roomName,
  planName,
  // roomId,
  // rateId,
  isRtl,
  titles,
  pax,
  selectedAddons,
  onAddonRemove,
  className
}) => {
  return (
    <div
      className={cx(styles.roomBody, className, {
        [styles.rtl]: isRtl
      })}
    >
      <Only when={!!roomName}>
        <div className={styles.name}>
          <div className={styles.withEllipsis}>{roomName}</div>
        </div>
      </Only>

      <PaxDetails className={styles.pax} pax={pax} titles={titles} />

      <Only when={!!planName}>
        <div className={styles.plan}>{planName}</div>
      </Only>

      <Only when={selectedAddons.length > 0}>
        <AddonsList
          className={styles.addons}
          addons={selectedAddons}
          titles={titles}
          onAddonRemove={onAddonRemove}
        />
      </Only>
    </div>
  );
};

RoomBody.defaultProps = {
  selectedAddons: []
};

RoomBody.propTypes = {
  // id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  roomName: PropTypes.string,
  planName: PropTypes.string,
  // currency: PropTypes.string,
  // currencyCode: PropTypes.string,
  //globalCurrencyCode: PropTypes.string,ד
  // roomId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // rateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  pax: PropTypes.object,
  selectedAddons: PropTypes.array,
  onAddonRemove: PropTypes.func
};

export default RoomBody;



// WEBPACK FOOTER //
// ./src/components/Cart/Rooms/Room/RoomBody/RoomBody.js